import { useState } from "react";

const useError = (defaultVal) => {
	return useState(defaultVal);
};

const NFTImage = ({ imageUrl }) => {
	const [error, setError] = useError(false);

	return (
		<div className="flex relative max-w-full object-cover shadow-inner" style={{ aspectRatio: "47 / 66" }}>
			<img
				className="hidden"
				src={imageUrl}
				alt="seeds"
				onError={() => {
					setTimeout(() => {
						setError(true);
					}, 3000);
				}}
			/>
			<div
				className="mb-1 z-10 absolute inset-0 overflow-hidden bg-no-repeat shadow-lg"
				style={{
					backgroundImage: `url('${imageUrl}')`,
					backgroundPosition: "top center",
					backgroundSize: "auto 100%",
				}}
			/>
			<div className={`flex justify-center items-center absolute inset-3 z-0 max-w-full ${error ? "bg-yellow-300" : "animate-pulse bg-primary/30"}`}>
				<p className="text-white text-shadow-md">{error ? "Pending" : "Loading"}</p>
			</div>
		</div>
	);
};

export default function NFTCard({ id, image }: { id: string; image: string; price: number }) {
	const openSeaLink = `https://opensea.io/assets/0xBCDf4823fC65e6aa243963f955fD5cE885066306/${id}`;

	return (
		<a className="bland w-full" href={openSeaLink} rel="noreferrer" target="_blank">
			<div className="flex flex-col flex-grow justify-items-center nft-image">
				<NFTImage imageUrl={image} />
			</div>
		</a>
	);
}
